// extracted by mini-css-extract-plugin
export var measureBox = "_a8-0";